
export default {
  'PRODUCT_ID': {
    title: '产品编号',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '产品编号'
    },
    width: 200
  },

  'PRODUCT_NAME': {
    title: '产品名称',
    type: 'input',
    width: 'auto'
  },
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/productDeploy.js